import { post } from '@/utils/request'

export function PostOrderStatistics(data) {
    return post('admin/Statistics/orderStatistics', data)
}